import React, { Component } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import TLDRDownloadOptions from "./TLDRDownloadOptions";
import { FETCH_STORY_PAGES } from "../../../_actions/endpoints";
import { Flex, Spinner } from "@chakra-ui/react";
import { getStoryStats } from "../../../_utils/common";
import { withTranslation } from "react-i18next";

const format = require("string-format");

class TLDRDownloadOptionsWrapper extends Component {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props);
    this.state = {
      pageIds: [],
      storyDuration: 0,
      isStoryHeightAndWidthConsistent: true,
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (
      (props.pageIds && props.pageIds !== state.pageIds) ||
      (props.storyDuration && props.storyDuration !== state.storyDuration)
    ) {
      return {
        pageIds: props.pageIds,
        storyDuration: props.storyDuration,
        isStoryHeightAndWidthConsistent: props.isStoryHeightAndWidthConsistent,
      };
    }

    // Return null to indicate no change to state.
    return null;
  }

  componentDidMount() {
    const { pageIds, show } = this.props;
    if (!show) {
      return;
    }
    if (!pageIds) {
      this.fetchPage();
    } else {
      this.setState({
        pageIds,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.show !== prevProps.show && this.props.show === true) {
      this.fetchPage();
    }
  }

  componentWillUnmount() {
    const { t } = this.props;
    this.signal.cancel("The user aborted a request.");
  }

  fetchPage() {
    const { story } = this.props;
    const storyId = story.payload.content_id || story.payload.id;

    let endpoint = format(FETCH_STORY_PAGES, storyId);
    axios.get(endpoint, { cancelToken: this.signal.token }).then((res) => {
      const pageIds = res.data.results.map((item) => item.id);
      const [isStoryHeightAndWidthConsistent, storyDuration] = getStoryStats(
        res.data.results
      );
      this.setState({
        pageIds,
        storyDuration,
        isStoryHeightAndWidthConsistent,
      });
    });
  }

  render() {
    const { t } = this.props;
    const {
      story,
      onDownloading,
      onArtBoardsSelectionChange,
      onExportEnd,
      disableSizeChange,
      disableTransparentChange,
      supportedFileTypes,
      maxVideoHeight,
      hideFileTypeHeader,
      inline,
    } = this.props;
    const { pageIds, storyDuration, isStoryHeightAndWidthConsistent } =
      this.state;

    const content = (
      <>
        {pageIds.length ? (
          <TLDRDownloadOptions
            story={story}
            storyDuration={storyDuration}
            isStoryHeightAndWidthConsistent={isStoryHeightAndWidthConsistent}
            onDownloading={onDownloading}
            onArtBoardsSelectionChange={onArtBoardsSelectionChange}
            pageIds={pageIds}
            disableSizeChange={disableSizeChange}
            disableTransparentChange={disableTransparentChange}
            supportedFileTypes={supportedFileTypes}
            maxVideoHeight={maxVideoHeight}
            hideFileTypeHeader={hideFileTypeHeader}
            onExportEnd={onExportEnd}
            inline={inline}
          />
        ) : (
          <Flex justifyContent="center">
            <Spinner size="sm" color="primary" mt={1} />
          </Flex>
        )}
      </>
    );

    if (inline) {
      return <div>{content}</div>;
    }

    return <>{content}</>;
  }
}

TLDRDownloadOptionsWrapper.propTypes = {
  pageIds: PropTypes.arrayOf(PropTypes.string),
  story: PropTypes.object.isRequired,
  storyDuration: PropTypes.number,
  isStoryHeightAndWidthConsistent: PropTypes.bool,
};

export default withTranslation(["navbar"])(TLDRDownloadOptionsWrapper);
